import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class IntegrationService {
    private integrationService = environment.integrationService + '/v1';

    constructor(private http: HttpClient) { }

    // Plugin APIs

    createPlugin(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + "/plugin", payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getPlugin(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/plugin/get?page=1&pageSize=10', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deletePlugin(deleteId: any): Observable<any> {
        return this.http.delete<any>(this.integrationService + '/plugin/' + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    getPluginById(editId: any): Observable<any> {
        return this.http.get<any>(this.integrationService + '/plugin/' + editId)
            .pipe(catchError((err) => throwError(err)));
    }

    updatePlugin(id: any, payload: any): Observable<any> {
        return this.http.put<any>(this.integrationService + '/plugin/' + id, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // Page APIs

    dublicateCheck(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/page/check-slug-title', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createPage(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/page', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getPageData(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/page/get?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getApproval(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/approval/get?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createApproval(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/approval`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateApproval(payload: any): Observable<any> {
        return this.http.put<any>(this.integrationService + `/approval/${payload._id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deletePage(deleteId: any): Observable<any> {
        return this.http.delete<any>(this.integrationService + '/page/' + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    getPageById(id: any): Observable<any> {
        return this.http.get<any>(this.integrationService + '/page/' + id)
            .pipe(catchError((err) => throwError(err)));
    }

    updatePage(payload: any, id: any): Observable<any> {
        return this.http.put<any>(this.integrationService + '/page/' + id, payload)
            .pipe(catchError((err) => throwError(err)));
    }


    // Page APIs


    dublicateBlog(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/blog/check-slug-title', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createBlog(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/blog', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getBlogData(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/blog/get?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteBlog(deleteId: any): Observable<any> {
        return this.http.delete<any>(this.integrationService + '/blog/' + deleteId)
            .pipe(catchError((err) => throwError(err)));
    }

    getBlogById(id: any): Observable<any> {
        return this.http.get<any>(this.integrationService + '/blog/' + id)
            .pipe(catchError((err) => throwError(err)));
    }

    updateBlog(payload: any, id: any): Observable<any> {
        return this.http.put<any>(this.integrationService + '/blog/' + id, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // Marketing APIs

    getTemplateByCriteria(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/message-template/criteria?page=1&pageSize=100', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createCampaign(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/campaign', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getCampaignByCriteria(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/campaign/all?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getCampaignMetaTags(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/campaign-meta-tags/get?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    sendWhatsappCampaign(payload:any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/campaign/send-campaign`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    sendTestWhatsappCampaign(payload:any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/whatsapp/send-msg`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createWhatsappCampaign(payload:any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/campaign`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    
    getWhatsappTemplates(payload:any, page:any, pageSize:any): Observable<any>{
        return this.http.post<any>(this.integrationService + `/whatsapp/get-templates?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    uploadWhatsappFile(payload:any): Observable<any>{
        return this.http.post<any>(this.integrationService + `/whatsapp/upload-file`, payload)
            .pipe(catchError((err) => throwError(err)));
    }


    // Notification

    getNotification(shopId: any, page: any, pageSize: any): Observable<any> {
        return this.http.get<any>(this.integrationService + `/notification/shop/${shopId}?page=${page}&pageSize=${pageSize}`)
            .pipe(catchError((err) => throwError(err)));
    }

    updateNotificationStatus(payload: any): Observable<any> {
        return this.http.put<any>(this.integrationService + `/notification/mark-read`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // Page Builder APIs

    getPageBuilder(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/page-builder/get?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }
    createPageBuilder(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/page-builder', payload)
            .pipe(catchError((err) => throwError(err)));
    }
    updatePageBuilder(payload: any, id: any): Observable<any> {
        return this.http.put<any>(this.integrationService + `/page-builder/${id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // Content Management
    getContentManagement(payload: any, page: any, pageSize: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/content-management/get?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    createContentManagement(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + '/content-management', payload)
            .pipe(catchError((err) => throwError(err)));
    }

    updateContentManagement(payload: any, id: any): Observable<any> {
        return this.http.put<any>(this.integrationService + `/content-management/${id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteContentManagement(id: any): Observable<any> {
        return this.http.delete<any>(this.integrationService + `/content-management/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    getContentManagementById(id: any): Observable<any> {
        return this.http.get<any>(this.integrationService + `/content-management/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    //Zalon AI
    generate(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/ai/generate`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    // Approval Analytics

    getApprovalStats(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/approval/total`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    //announcements
    createAnnouncement(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/announcement`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAnnouncementsByCriteria(payload: any, page:any, pageSize:any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/announcement/all?page=${page}&pageSize=${pageSize}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    getAnnouncementById(id: any): Observable<any> {
        return this.http.get<any>(this.integrationService + `/announcement/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    updateAnnouncement(id: any, payload:any): Observable<any> {
        return this.http.put<any>(this.integrationService + `/announcement/${id}`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    sendAnnouncement(payload: any): Observable<any> {
        return this.http.post<any>(this.integrationService + `/announcement/send`, payload)
            .pipe(catchError((err) => throwError(err)));
    }

    deleteAnnouncement(id: any): Observable<any> {
        return this.http.delete<any>(this.integrationService + `/announcement/${id}`)
            .pipe(catchError((err) => throwError(err)));
    }

    sendEmail (emailInputs: any, headers: any) : Observable<any> {
        return  this.http.post(this.integrationService + `/email/send-email`, {
                uniqueIdentifier: emailInputs.uniqueIdentifier,
                email: emailInputs.email,
                subject: emailInputs.subject,
                body: emailInputs.body
            }, {
                headers: headers
            });
    }

}